export default "__VITE_ASSET__ZFwmCSOB__"